import React, { useEffect } from "react";

import {
  Heading,
  P,
  SectionHeading,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";
import Menu from "./menu";
import styled from "@emotion/styled";
import { Container, Grid, Typography } from "@mui/material"; 

import Aos from "aos";
import "aos/dist/aos.css";
const Background = styled.div`
  background-color: black;
  // background: url("/images/bg.png");
  // background-repeat: no-repeat;
  // background-position: center;
  // background-size: cover;
  // min-height: 100vh;
  // display: flex;
  // align-items: center;
  // @media screen and (max-width: 899px) {
  //   padding: 100px 0 0 0;
  // }
`;
const ReadMore = styled.a`
  text-decoration: none;
  cursor: pointer;
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : "#fff")};
  color: ${(props) => (props.color ? props.color : "#000")};
  border: ${(props) => (props.border ? props.border : "1px solid #fff")};
  margin-right: 20px;
  border-radius: 10px;
  padding: 8px 40px;
  font-family: "Poppins-Regular";
  font-size: 14px;
  @media screen and (max-width: 899px) {
    padding: ${(props) => (props.p599 ? props.p599 : "5px 27px")};
  }
  @media screen and (max-width: 350px) {
    padding: ${(props) => (props.p599 ? props.p599 : "5px 20px")};
  }

  /* box-shadow: ${(props) =>
    props.bs ? props.bs : "inset 0px 2px 5px 0px #FED0AE"}; */
  &:hover {
    opacity: 0.9;
  }
`;
const Intro = styled(Grid)`
  padding: 50px 0;
  display: flex;
  align-items: end;
  @media screen and (max-width: 899px) {
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
`;
const IntroImage = styled(Grid)`
  padding: 50px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 899px) {
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
`;
const Div = styled.div`
  padding: 50px 0;
  @media screen and (max-width: 899px) {
    padding: 70px 0;
    width: 50%;
  }
`;
const HeaderImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 300px;
`;

const Index = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <div>
      <Menu />
      <Background>
        <Container maxWidth="xl">
          <Grid container style={{ textAlign: "center" }}>
            <Intro xs={12} md={12} p599="30px 0 0 0" align="center">
              <Div style={{ width: "100%" }}>
                <HeaderImage
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in"
                  data-aos-delay="500"
                  data-aos-duration="500"
                  data-aos-offset="0"
                  src="/images/ape.gif"
                />
                <SectionHeading
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in"
                  data-aos-delay="600"
                  data-aos-duration="600"
                  data-aos-offset="0"
                >
                  Blockchain For Apes{" "}
                </SectionHeading>
                <SectionHeading
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in"
                  data-aos-delay="600"
                  data-aos-duration="600"
                  data-aos-offset="0"
                >
                  From The Apes
                </SectionHeading>
                <P
                  maxWidth="100%"
                  p="0px 0px 30px 0"
                  align="center"
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in"
                  data-aos-delay="700"
                  data-aos-duration="700"
                  data-aos-offset="0"
                >
                  Proof of Ape is building a dedicated blockchain that is made
                  for the apes, by the apes.
                </P>
                <ReadMore
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in"
                  data-aos-delay="800"
                  data-aos-duration="800"
                  data-aos-offset="0"
                  border="none"
                  color="#fff"
                  bgcolor="#004F64"
                  href="/"
                  target="_blank"
                >
                  POA Explorer
                </ReadMore>
                <ReadMore
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in"
                  data-aos-delay="800"
                  data-aos-duration="800"
                  data-aos-offset="0"
                  color="#fff"
                  bgcolor="#000"
                  href="https://medium.com/@zaffre_73091/apecoin-2-0-4d3abad58339"
                  target="_blank"
                >
                  Read More
                </ReadMore>
              </Div>
            </Intro>
            {/* <IntroImage
              xs={12}
              md={6}
              data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              // data-aos-delay="500"
              // data-aos-offset="0"
              data-aos-duration="1500"
            >
              
            </IntroImage> */}
          </Grid>
        </Container>
      </Background>
    </div>
  );
};

export default Index;
